// src/stone/icons/Clock24.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Clock24 = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M20 4.334c-8.652 0-15.667 7.014-15.667 15.667S11.348 35.667 20 35.667s15.667-7.014 15.667-15.666S28.652 4.334 20 4.334M2.333 20.001c0-9.757 7.91-17.667 17.667-17.667s17.667 7.91 17.667 17.667S29.757 37.667 20 37.667 2.333 29.757 2.333 20.001"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M20 9a1 1 0 0 1 1 1v9.382l6.114 3.057a1 1 0 1 1-.895 1.789l-6.666-3.334A1 1 0 0 1 19 20V10a1 1 0 0 1 1-1"
        }
      )
    ]
  }
);
var Clock24_default = Clock24;

export {
  Clock24,
  Clock24_default
};
